module.exports = __webpack_public_path__ + "static/media/trump.063c8281.webp";